import React from 'react';
import { BarcodeComponents } from '../../../types/logistics';
import { parseBarcode } from '../../../utils/barcode-format';
import './BarcodeDisplay.scss';

interface BarcodeDisplayProps {
  barcode: string | null;
  boxId?: number;
  barcodeComponents?: BarcodeComponents | null;
}

/**
 * Renders a barcode with structured formatting:
 * - prefix (dimmed): customer + order digits
 * - suffix (highlighted): box ID digits (includes check digit for EAN-13)
 *
 * Renders as a fragment so spans are direct children of
 * the parent .barcode div, preserving existing CSS selectors.
 */
export default function BarcodeDisplay({ barcode, boxId, barcodeComponents }: BarcodeDisplayProps) {
  if (!barcode) {
    return <span className="box-id-fallback">Box #{boxId}</span>;
  }

  const parsed = parseBarcode(barcode, barcodeComponents);

  return (
    <>
      <span className="prefix">{parsed.prefix}</span>
      <span className="suffix">{parsed.boxId}</span>
    </>
  );
}
